// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a6c73539","96":"a6c73539","110":"b450d54b","597":"a6c73539","770":"a6c73539","862":"a6c73539","976":"a6c73539"}[chunkId] + ".chunk.css";
};